<template>
  <div class="page-card">
    <el-card>
      <div slot="header">优惠券管理 - 优惠券活动</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="活动名称">
          <el-input v-model="query.name" placeholder="活动名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增活动</el-button>
          <el-button @click="downloadTemplate">下载模板</el-button>
          <el-upload
            style="display:inline-block;margin-left:8px;"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleImportFile"
            accept=".csv,.xls,.xlsx"
          >
            <el-button>导入文件</el-button>
          </el-upload>
          <el-button
            type="danger"
            :disabled="!multipleSelection.length"
            style="margin-left:8px;"
            @click="batchRemove"
          >批量删除</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="活动名称" />
        <el-table-column prop="couponType" label="券类型" />
        <el-table-column prop="validFrom" label="开始时间" width="160" />
        <el-table-column prop="validTo" label="结束时间" width="160" />
        <el-table-column prop="redeemScope" label="核销距离" width="160" />
        <el-table-column prop="exchangePoints" label="兑换积分" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.exchangePoints != null && scope.row.exchangePoints !== '' ? scope.row.exchangePoints : '自动' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="issueTotal" label="发放总量" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.issueTotal != null && scope.row.issueTotal !== '' ? scope.row.issueTotal : '不限' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalIssued" label="发放量" width="90" />
        <el-table-column prop="totalUsed" label="核销量" width="90" />
        <el-table-column prop="useRate" label="核销率" width="90" />
        <el-table-column label="可多领" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.allowRepeatClaim ? 'success' : 'info'" size="mini">
              {{ scope.row.allowRepeatClaim ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="editForm.id ? '编辑活动' : '新增活动'"
        :visible.sync="editVisible"
        width="600px"
      >
        <el-form :model="editForm" ref="editForm" label-width="90px">
          <el-form-item label="活动名称" required>
            <el-input v-model="editForm.name" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="券类型" required>
            <el-select v-model="editForm.couponType" placeholder="请选择券类型" style="width: 100%;">
              <el-option label="折扣券" value="折扣券" />
            </el-select>
          </el-form-item>
          <el-form-item label="有效期" required>
            <el-date-picker
              v-model="editRange"
              type="datetimerange"
              value-format="yyyy-MM-ddTHH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="规则说明">
            <el-input type="textarea" :rows="4" v-model="editForm.rules" placeholder="如：满100减10" />
          </el-form-item>
          <el-form-item label="核销距离">
            <el-input
              v-model="editForm.redeemScope"
              placeholder="如：2000、2000米、2km（留空则用系统默认核销距离）"
              clearable
            />
          </el-form-item>
          <el-form-item label="兑换所需积分">
            <el-input
              v-model="editForm.exchangePoints"
              placeholder="留空则按规则自动推算（与小程序一致）"
              clearable
            />
            <div class="form-hint">填写正整数：积分中心将按此扣积分；留空时按折扣规则自动计算。</div>
          </el-form-item>
          <el-form-item label="发放总量">
            <el-input
              v-model="editForm.issueTotal"
              placeholder="留空表示不限，填写正整数表示发完即止"
              clearable
            />
          </el-form-item>
          <el-form-item label="可多领">
            <el-switch v-model="editForm.allowRepeatClaim" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'
import * as XLSX from 'xlsx'

export default {
  name: 'CouponCampaignList',
  data() {
    return {
      query: {
        name: ''
      },
      list: [],
      multipleSelection: [],
      editVisible: false,
      editForm: {
        id: null,
        name: '',
        couponType: '折扣券',
        validFrom: '',
        validTo: '',
        rules: '',
        redeemScope: '',
        exchangePoints: '',
        issueTotal: '',
        allowRepeatClaim: false
      },
      editRange: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/promo/coupon-campaigns', { params: this.query }).then(res => {
        const data = res.data || res
        this.list = (data && data.items) || []
      }).catch((e) => {
        this.$message.error((e && (e.msg || e.message)) || '加载失败')
      })
    },
    resetQuery() {
      this.query.name = ''
      this.fetchList()
    },
    parseAllowRepeatClaimCell(arr, idx) {
      const i = idx('allowRepeatClaim')
      if (i < 0) return false
      const v = String(arr[i] != null ? arr[i] : '')
        .trim()
        .toLowerCase()
      return v === '1' || v === 'true' || v === 'yes' || v === 'y' || v === '是'
    },
    openEdit(row) {
      if (row && row.id) {
        // 编辑时始终拉详情，避免列表字段缺失导致“数据消失”
        request.get(`/promo/coupon-campaigns/${row.id}`).then(res => {
          const data = (res.data || res) || {}
          this.editForm = {
            id: data.id,
            name: data.name || '',
            couponType: data.couponType || '折扣券',
            validFrom: data.validFrom || '',
            validTo: data.validTo || '',
            rules: data.rules || '',
            redeemScope: data.redeemScope || '',
            exchangePoints: data.exchangePoints != null && data.exchangePoints !== '' ? String(data.exchangePoints) : '',
            issueTotal: data.issueTotal != null && data.issueTotal !== '' ? String(data.issueTotal) : '',
            allowRepeatClaim: !!data.allowRepeatClaim
          }
          this.editRange = this.editForm.validFrom && this.editForm.validTo ? [this.editForm.validFrom, this.editForm.validTo] : []
          this.editVisible = true
        }).catch(() => {
          this.$message.error('获取活动详情失败')
        })
        return
      }
      this.editForm = {
        id: null,
        name: '',
        couponType: '折扣券',
        validFrom: '',
        validTo: '',
        rules: '',
        redeemScope: '',
        exchangePoints: '',
        issueTotal: '',
        allowRepeatClaim: false
      }
      this.editRange = []
      this.editVisible = true
    },
    saveEdit() {
      if (!this.editForm.name) {
        this.$message.warning('请输入活动名称')
        return
      }
      if (!this.editForm.couponType) {
        this.$message.warning('请选择券类型')
        return
      }
      if (!this.editRange || this.editRange.length !== 2) {
        this.$message.warning('请选择有效期')
        return
      }
      const payload = {
        name: this.editForm.name,
        couponType: '折扣券',
        validFrom: this.editRange[0],
        validTo: this.editRange[1],
        rules: this.editForm.rules,
        redeemScope: this.editForm.redeemScope,
        exchangePoints: this.editForm.exchangePoints === '' || this.editForm.exchangePoints == null
          ? null
          : this.editForm.exchangePoints,
        issueTotal: this.editForm.issueTotal === '' || this.editForm.issueTotal == null
          ? null
          : this.editForm.issueTotal,
        allowRepeatClaim: !!this.editForm.allowRepeatClaim
      }
      const req = this.editForm.id
        ? request.put(`/promo/coupon-campaigns/${this.editForm.id}`, payload)
        : request.post('/promo/coupon-campaigns', payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.editVisible = false
        this.fetchList()
      })
    },
    remove(row) {
      this.$confirm('确认删除该活动吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/promo/coupon-campaigns/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || []
    },
    batchRemove() {
      const ids = (this.multipleSelection || []).map(x => x.id).filter(Boolean)
      if (!ids.length) return
      this.$confirm(`确认删除选中的 ${ids.length} 条活动吗？`, '提示', { type: 'warning' }).then(() => {
        Promise.all(ids.map(id => request.delete(`/promo/coupon-campaigns/${id}`)))
          .then(() => {
            this.$message.success('批量删除成功')
            this.fetchList()
            this.multipleSelection = []
          })
      })
    },
    downloadTemplate() {
      // 用 Excel 可以直接打开的 HTML Table 生成 .xls（无需引入 xlsx 依赖）
      const headers = ['name', 'couponType', 'validFrom', 'validTo', 'rules', 'redeemScope', 'issueTotal', 'allowRepeatClaim']
      const sample = ['示例活动', '折扣券', '2026-03-01T00:00:00', '2026-03-31T23:59:59', '到店享受商家折扣优惠', '2000米', '1000', '0']
      const escapeHtml = s =>
        String(s)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      const table = `
        <html>
          <head>
            <meta charset="utf-8" />
          </head>
          <body>
            <table border="1">
              <tr>${headers.map(h => `<th>${escapeHtml(h)}</th>`).join('')}</tr>
              <tr>${sample.map(v => `<td>${escapeHtml(v)}</td>`).join('')}</tr>
            </table>
          </body>
        </html>
      `
      const blob = new Blob([table], { type: 'application/vnd.ms-excel;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'coupon_campaigns_template.xls'
      a.click()
      URL.revokeObjectURL(url)
    },
    async handleImportFile(file) {
      try {
        const raw = file && (file.raw || file)
        if (!raw) return
        const name = (raw.name || '').toLowerCase()
        const isXlsx = name.endsWith('.xlsx') || name.endsWith('.xls')
        if (isXlsx) {
          const buffer = await raw.arrayBuffer()
          const wb = XLSX.read(buffer, { type: 'array' })
          const sheetName = wb.SheetNames && wb.SheetNames[0]
          if (!sheetName) {
            this.$message.warning('Excel 内容为空')
            return
          }
          const ws = wb.Sheets[sheetName]
          const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, defval: '' })
          if (!rows || rows.length < 2) {
            this.$message.warning('Excel 内容为空')
            return
          }
          const header = (rows[0] || []).map(s => String(s || '').trim())
          const idx = k => header.indexOf(k)
          const required = ['name', 'couponType', 'validFrom', 'validTo']
          for (const k of required) {
            if (idx(k) === -1) {
              this.$message.error(`Excel 缺少列: ${k}`)
              return
            }
          }
          const items = rows.slice(1).filter(arr => Array.isArray(arr) && arr.some(cell => String(cell || '').trim()))
          if (!items.length) {
            this.$message.warning('Excel 无有效数据行')
            return
          }
          this.$message.info(`开始导入 ${items.length} 条...`)
          for (const arr of items) {
            const payload = {
              name: (arr[idx('name')] || '').trim(),
              couponType: '折扣券',
              validFrom: (arr[idx('validFrom')] || '').trim(),
              validTo: (arr[idx('validTo')] || '').trim(),
              rules: idx('rules') !== -1 ? (arr[idx('rules')] || '').trim() : '',
              redeemScope: idx('redeemScope') !== -1 ? (arr[idx('redeemScope')] || '').trim() : '',
              issueTotal: idx('issueTotal') !== -1 ? (arr[idx('issueTotal')] || '').trim() : null,
              allowRepeatClaim: this.parseAllowRepeatClaimCell(arr, idx)
            }
            if (!payload.name || !payload.couponType || !payload.validFrom || !payload.validTo) continue
            await request.post('/promo/coupon-campaigns', payload)
          }
          this.$message.success('导入完成')
          this.fetchList()
          return
        }
        const text = await raw.text()
        const parseHtmlTable = html => {
          const strip = s => String(s || '').replace(/<[^>]+>/g, '').trim()
          const decode = s =>
            strip(s)
              .replace(/&nbsp;/g, ' ')
              .replace(/&quot;/g, '"')
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/&amp;/g, '&')
              .trim()

          const tableMatch = html.match(/<table[\s\S]*?<\/table>/i)
          if (!tableMatch) return null
          const tableHtml = tableMatch[0]

          const trRe = /<tr[^>]*>([\s\S]*?)<\/tr>/gi
          const cellRe = /<(td|th)[^>]*>([\s\S]*?)<\/\1>/gi

          const rows = []
          let tr
          while ((tr = trRe.exec(tableHtml))) {
            const rowHtml = tr[1]
            const cells = []
            let td
            cellRe.lastIndex = 0
            while ((td = cellRe.exec(rowHtml))) {
              cells.push(decode(td[2]))
            }
            if (cells.length) rows.push(cells)
          }
          return rows.length ? rows : null
        }

        // 1) Excel（HTML Table）优先
        if (text.includes('<table')) {
          const rows = parseHtmlTable(text)
          if (!rows || rows.length < 2) {
            this.$message.warning('Excel 表格内容为空或格式不正确')
            return
          }

          const header = rows[0].map(s => (s || '').trim())
          const idx = k => header.indexOf(k)
          const required = ['name', 'couponType', 'validFrom', 'validTo']
          for (const k of required) {
            if (idx(k) === -1) {
              this.$message.error(`Excel 缺少列: ${k}`)
              return
            }
          }

          const items = rows.slice(1).filter(arr => Array.isArray(arr) && arr.length >= 4)
          if (!items.length) {
            this.$message.warning('Excel 无有效数据行')
            return
          }

          this.$message.info(`开始导入 ${items.length} 条...`)
          for (const arr of items) {
            const payload = {
              name: (arr[idx('name')] || '').trim(),
              couponType: '折扣券',
              validFrom: (arr[idx('validFrom')] || '').trim(),
              validTo: (arr[idx('validTo')] || '').trim(),
              rules: idx('rules') !== -1 ? (arr[idx('rules')] || '').trim() : '',
              redeemScope: idx('redeemScope') !== -1 ? (arr[idx('redeemScope')] || '').trim() : '',
              issueTotal: idx('issueTotal') !== -1 ? (arr[idx('issueTotal')] || '').trim() : null,
              allowRepeatClaim: this.parseAllowRepeatClaimCell(arr, idx)
            }
            if (!payload.name || !payload.couponType || !payload.validFrom || !payload.validTo) continue
            await request.post('/promo/coupon-campaigns', payload)
          }

          this.$message.success('导入完成')
          this.fetchList()
          return
        }

        // 2) CSV 兼容
        const lines = text.split(/\\r?\\n/).map(s => s.trim()).filter(Boolean)
        if (lines.length < 2) {
          this.$message.warning('CSV 内容为空')
          return
        }
        const header = lines[0].split(',').map(s => s.trim())
        const idx = k => header.indexOf(k)
        const required = ['name', 'couponType', 'validFrom', 'validTo']
        for (const k of required) {
          if (idx(k) === -1) {
            this.$message.error(`CSV 缺少列: ${k}`)
            return
          }
        }
        const items = lines.slice(1).map(line => line.split(',')).filter(arr => arr.length >= 4)
        if (!items.length) {
          this.$message.warning('CSV 无有效数据行')
          return
        }

        this.$message.info(`开始导入 ${items.length} 条...`)
        for (const arr of items) {
          const payload = {
            name: (arr[idx('name')] || '').trim(),
            couponType: '折扣券',
            validFrom: (arr[idx('validFrom')] || '').trim(),
            validTo: (arr[idx('validTo')] || '').trim(),
            rules: idx('rules') !== -1 ? (arr[idx('rules')] || '').trim() : '',
            redeemScope: idx('redeemScope') !== -1 ? (arr[idx('redeemScope')] || '').trim() : '',
            issueTotal: idx('issueTotal') !== -1 ? (arr[idx('issueTotal')] || '').trim() : null,
            allowRepeatClaim: this.parseAllowRepeatClaimCell(arr, idx)
          }
          if (!payload.name || !payload.couponType || !payload.validFrom || !payload.validTo) continue
          await request.post('/promo/coupon-campaigns', payload)
        }
        this.$message.success('导入完成')
        this.fetchList()
      } catch (e) {
        this.$message.error('导入失败：请确认 Excel/CSV 格式正确')
      }
    }
  }
}
</script>

<style scoped>
.form-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 6px;
}
</style>

